var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntellectualProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58 50.51C8.11 50.51 10.16 48.46 10.16 45.93V41.35H4.88C2.74 41.36 1 43.09 1 45.23V45.93C1 48.46 3.05 50.51 5.58 50.51Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0003 5.15999V46.72L49.8003 49.01L47.2203 50.43H7.03027L10.1603 47.31V5.15999C10.1603 3.12999 11.8003 1.48999 13.8303 1.48999H47.3303C49.3603 1.48999 51.0003 3.13999 51.0003 5.15999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0004 41.36V5.52999C51.0004 3.29999 49.1904 1.48999 46.9604 1.48999H14.1904C11.9604 1.48999 10.1504 3.29999 10.1504 5.52999V41.36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8604 32.67H44.2904",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8604 37.99H44.2904",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8604 43.31H34.6003",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58 50.51C8.11 50.51 10.16 48.46 10.16 45.93V41.35H5.03C2.81 41.36 1 43.16 1 45.39V45.93C1 48.46 3.05 50.51 5.58 50.51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4199 50.51C48.9499 50.51 50.9999 48.46 50.9999 45.93V41.35",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4201 50.51H44.2901H5.58008",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5797 9.98001L34.4697 7.70001L35.6097 12.07L39.9697 13.21L37.6897 17.1L39.9697 20.99L35.6097 22.13L34.4697 26.49L30.5797 24.21L26.6897 26.49L25.5397 22.13L21.1797 20.99L23.4597 17.1L21.1797 13.21L25.5397 12.07L26.6897 7.70001L30.5797 9.98001Z",
    fill: "#FFCF00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5797 9.98001L34.4697 7.70001L35.6097 12.07L39.9697 13.21L37.6897 17.1L39.9697 20.99L35.6097 22.13L34.4697 26.49L30.5797 24.21L26.6897 26.49L25.5397 22.13L21.1797 20.99L23.4597 17.1L21.1797 13.21L25.5397 12.07L26.6897 7.70001L30.5797 9.98001Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellectualProperty);
export default __webpack_public_path__ + "static/media/IntellectualProperty.ae5750115f99cf08c4ad0529415f8afb.svg";
export { ForwardRef as ReactComponent };